export default {
    memberDataSection: {
        import: "Impor",
        buyingStation: "Stasiun Pembelian",
        societies: "Masyarakat",
        affiliates: "Afiliasi",
        societyInfo: "Info Masyarakat",
        continue: "Lanjutkan",
        farmerId: "ID Petani",
        farmerName: "Nama Petani",
        farmerAddress: "Alamat Petani",
        quality: "Kualitas",
        quantity: "Kuantitas",
        importAll: "Impor Semua",
        importSelected: "Impor yang Dipilih",
        fileLoaded: "Berkas berhasil dimuat",
        incorrectHeaders: "Header salah",
        processingBatch: "Memproses Batch",
        purchaseOrder: "Pesanan Pembelian",
        startDate: "Tanggal Mulai",
        endDate: "Tanggal Akhir",
        purchasingOrder: "Pesanan Pembelian",
        totalCoffeeCherry: "Total Biji Kopi Cherry",
        airHumidity: "Kelembapan Udara",
        density: "Kepadatan",
        temperature: "Suhu",
        beanMoistureContent: "Kandungan Air Biji Kopi",
        processType: "Jenis Proses",
        batchRating: "Pilih Rating Batch",
        purchaseDate: "Tanggal Pembelian",
        selectFarmer: "Pilih Petani",
        selectFarm: "Pilih Perkebunan",
        selectPlantation: "Pilih Perkebunan",
        coffeeVariety: "Varietas Kopi",
        coffeeSpecies: "Spesies Kopi",
        coffeeCherryQuantity: "Kuantitas Biji Kopi Cherry",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        coffeeType: "Tipe Kopi",
        pricePerKg: "Harga Per Kg",
        processingDone: "Pengolahan Selesai",
        processedCoffeeOut: "Kopi yang Diproses Keluar",
        farmer: "Petani",
        farm: "Perkebunan",
        plantation: "Perkebunan",
        farmers: "Petani",
        selectCrop: "Pilih Tanaman",
        farmLimitUsed: "Batas Penggunaan Perkebunan",
        phoneNumber: "Nomor Telepon",
        farmSize: "Ukuran Perkebunan",
        farmLocation: "Lokasi Perkebunan",
        date: "Tanggal",
        status: "Status",
        noFarmers: "Tidak Ada Petani Ditemukan",
        approveReject: "Terima / Tolak",
        farms: "Perkebunan",
        crops: "Tanaman",
        equipment: "Peralatan",
        noFarms: "Tidak Ada Perkebunan Ditemukan",
        views: "Lihat",
        selectStatus: "Pilih Status",
        approved: "Disetujui",
        rejected: "Ditolak",
        reject: "Tolak",
        approve: "Setujui",
        conclude:"Selesaikan",
        cancel: "Batal",
        add: "Tambah",
        describeYourReason: "Deskripsikan alasan Anda di sini",
        userInformation: "Informasi Pengguna",
        userFarmRequest: "Permintaan Perkebunan Pengguna",
        userFarmInformation: "Informasi Perkebunan Pengguna",
        activity: "Aktivitas",
        activityType: "Tipe Aktivitas",
        farmZone: "Zona Perkebunan",
        farmerView: "Tampilan Petani",
        cropType: "Tipe Tanaman",
        cropVarity: "Varietas Tanaman",
        area: "Luas",
        cost: "Biaya",
        geofence: "Geofence",
        map_views: "Tampilan Peta",
        viewAllFarms: "Lihat Semua Perkebunan",
        farmersDetails: "Detail Petani",
        download: "Unduh",
        pOrder: {
          addNew: "Tambah Baru",
          viewAll: "Lihat Semua",
          selectDate: "Pilih tanggal",
          makeSelection: "Pilih salah satu",
          coffeeType: "Tipe kopi kuantitas",
          enterPrice: "Masukkan Harga",
          reqPurchaseDate: "Tanggal pembelian diperlukan",
          reqFarmer: "Petani diperlukan",
          reqCoffeeQnty: "Kuantitas Biji Kopi Cherry diperlukan",
          reqPrice: "Harga Per Kg diperlukan",
          grandTotal: "TOTAL BESAR",
          selectDateRange: "Pilih Rentang Tanggal",
          import: "Impor",
          purchaseId: "ID Pembelian",
          purchaseDate: "Tanggal Pembelian",
          farmerName: "Nama Petani",
          quality: "Kualitas",
          quantity: "Kuantitas",
          pricePerKg: "Harga Per Kg",
          selectBuyingStation: "Pilih stasiun pembelian",
          searchUser: "Cari Pengguna",
        },
        farmActivity: "Aktivitas Perkebunan",
        showOnMap: "Tampilkan di Peta",
        farmInformation: "Informasi Perkebunan",
        dateOfEntry: "Tanggal Masuk",
        farmID: "ID Perkebunan",
        ownershipType: "Tipe Kepemilikan",
        locationAddress: "Alamat Lokasi",
        goalType: "Tipe Tujuan",
        totalSize: "Ukuran Total",
        zones: "Zona",
        farmActivities: "Aktivitas Perkebunan",
        farmDetails: "Detail Perkebunan",
        totalFarmsRegistered: "Total Perkebunan Terdaftar",
        totalFarmArea: "Total Luas Perkebunan",
        totalZone: "Total Zona",
        zone: "Zona",
        totalCost: "Total Biaya",
        selectFarmZone: "Pilih Zona / Perkebunan",
        productionType: "Tipe Produksi",
        certifications: "Sertifikasi",
        geofences: "Geofences",
        farmsChart: "Grafik Perkebunan",
        
        // Buying Station specific translations
        buyingStations: "Stasiun Pembelian",
        registerBuyingStation: "Daftarkan Stasiun Pembelian",
        registerAffiliate: "Daftarkan Afiliasi",
        loadingAffiliate: "Memuat Afiliasi...",
        loadingBuyingStation: "Memuat Stasiun Pembelian...",
        searchBuyingStation: "Cari Stasiun Pembelian",
        searchAffiliate: "Cari Afiliasi",
        nameAndId: "Nama / ID",
        email: "Email",
        mobileNumber: "Nomor Ponsel",
        role: "Peran",
        actions: "Tindakan",
        view: "Lihat",
        edit: "Edit",
        activate: "Aktifkan",
        deactivate: "Nonaktifkan",
        society: "Masyarakat",
        operator: "Operator",
        supplier: "Pemasok",
        active: "Aktif",
        deactivated: "Dinonaktifkan",
        activatedSuccessfully: "Stasiun pembelian berhasil diaktifkan",
        deactivatedSuccessfully: "Stasiun pembelian berhasil dinonaktifkan",
        deletedSuccessfully: "Stasiun pembelian berhasil dihapus",
        duplicatedSuccessfully: "Stasiun pembelian berhasil diduplikasi",
        confirmDialog: {
          delete: {
            title: "Hapus Stasiun Pembelian",
            message: "Apakah Anda yakin ingin menghapus stasiun pembelian ini?",
            confirmBtn: "Hapus",
          }
        },
        registerNewAffiliate: "Daftarkan Afiliasi Baru",
        selectHowYouWantToProceed: "Pilih bagaimana Anda ingin melanjutkan",
        single: "Single",
        multiple: "Multiple",
        user: "User",
        createNewAffiliate: "Daftarkan Afiliasi Baru",
        affiliateName: "Nama Afiliasi",
        affiliateNumber: "Nomor Afiliasi",
        firstName: "Nama",
        lastName: "Nama Belakang",
        primaryEmailAddress: "Email Utama",
        submit: "Submit",
      },
}